export default __webpack_public_path__ + "static/media/SLIDER-VimeVest.dc9a7dc9.png";